<template>
  <div>
    <form v-if="!alreadyPaid" id="paypalpayment" action="https://www.paypal.com/de/cgi-bin/webscr" method="post">
      <input type="hidden" name="item_name" :value="'Deine Bestellung ' + orderId + ' bei ' + order.hostname">
      <input type="hidden" name="item_number" :value="orderId">
      <input type="hidden" name="amount" :value="amount">
      <input type="hidden" name="cmd" value="_xclick">
      <input type="hidden" name="no_note" value="1">
      <input type="hidden" name="business" value="info@foodi.de">
      <input type="hidden" name="currency_code" value="EUR">
      <input type="hidden" name="return" :value="returnUrl">
      <input type="hidden" name="no_shipping" value="1">
      <input type="hidden" name="txn_type" value="express_checkout">
      <input type="hidden" name="notify_url" value="https://api.foodi.de/paypal/ipn/">
      <input type="hidden" name="cancel_return" :value="cancelUrl">
      <input type="submit" name="Submit" value="Klicke hier, wenn du nicht automatisch weitergeleitet wirst">
    </form>

    <div v-if="alreadyPaid" class="bg-orange-lightest border-l-4 border-orange text-orange-dark p-4 mb-4" role="alert">
      <p class="font-bold">Bereits bezahlt</p>
      <p>Deine Bestellung wurde bereits bezahlt 🤯</p>
      <router-link tag="a" :to="{ name: 'Archiv' }" class="block my-4 text-black">zum Archiv</router-link>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import endpoints from '../../endpoints'

export default {
  name: 'PayPal',

  data () {
    return {
      hostId: window.hostId,
      orderId: this.$route.params.orderId,
      order: {},
      alreadyPaid: false
    }
  },

  computed: {
    amount: function () {
      const paymentFee = (this.order.freewebpayment === 'Y' ? 0 : 0.5)
      return (this.order.total + paymentFee)
    },

    returnUrl: function () {
      return window.location.origin + '/danke'
    },

    cancelUrl: function () {
      return window.location.origin + '/archiv'
    }
  },

  created () {
    axios.post(endpoints.getpaymentdetailsbyorderid, {
      'orderId': this.orderId
    })
      .then(({ data }) => {
        this.order = data.order
        this.alreadyPaid = data.paid

        if (!data.paid) {
          window.setTimeout(() => document.getElementById('paypalpayment').submit(), 300)
        }
      })
      .catch(e => {
        console.log(e)
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/paypal/redirect.vue